import React from 'react'
import MakeHomepage from '../make-homepage'

const MakeHomepageDe = () => {
    return <MakeHomepage languageCode="de" />
}

export default MakeHomepageDe
